import { render, staticRenderFns } from "./LazyComponentMixin.vue?vue&type=template&id=495814ba&"
import script from "./LazyComponentMixin.vue?vue&type=script&lang=js&"
export * from "./LazyComponentMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports